import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET PHONE TYPES
// ===================================================================================
export const phoneTypesLoading = () => {
	return {
		type: "PHONE_TYPE_IS_LOADING"
	};
};

export const phoneTypesError = err => {
	return {
		type: "PHONE_TYPE_HAS_ERROR",
		err
	};
};

export const phoneTypesSuccess = data => {
	return {
		type: "PHONE_TYPE_SUCCESS",
		data
	};
};

export function getPhoneTypes() {
	return dispatch => {
		dispatch(phoneTypesLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "phone-types", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(phoneTypesError(response.data.errors));
				} else {
					dispatch(phoneTypesSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(phoneTypesError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/phoneTypes.js